module.exports = __webpack_public_path__ + "static/img/1_1.7f7f4438.png";